import { Modal, Button, Form } from "react-bootstrap";

const EditInvoiceModal = ({ show, handleClose, data }) => {
  if (!data) return null;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Invoice</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Title</Form.Label>
          <Form.Control defaultValue={data.title} />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Amount</Form.Label>
          <Form.Control defaultValue={data.amount} />
        </Form.Group>

        <Form.Group>
          <Form.Label>Status</Form.Label>
          <Form.Select defaultValue={data.status}>
            <option>Paid</option>
            <option>Hold</option>
            <option>Unpaid</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="btn-orange">
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditInvoiceModal;